import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { MDText } from 'i18n-react';
import noop from 'lodash/noop';

import { withLocale, TSymbolProp } from '@adsk/bim360-matrix-react-helpers/es/locale';
import UserAvatar from '@adsk/bim360-matrix-react-user-avatar';
import Button from '@adsk/bim360-matrix-react-button';
import A from '@adsk/bim360-matrix-react-a';

import './_UserMenu.scss';

/**
 * UserMenu component that displays the user menu popover
 **/
export class UserMenu extends Component {
  /**
   * UserMenu component constructor.
   * @param props
   */
  constructor(props) {
    super(props);
  }

  /**
   * Called when the user requests to signout.
   */
  signout() {
    this.props.onSignout();
    if (this.props.signoutURL) {
      window.location.href = this.props.signoutURL;
    }
  }

  renderNotificationSettings() {
    const { hideNotificationSettings, isFedRAMP } = this.props;
    if (!hideNotificationSettings && !isFedRAMP) {
      return (
        <Button
          className="UserMenu__user-notification-settings"
          styleType={Button.StyleType.INLINE_LINK}
          onClick={this.props.openNotificationSettings}
        >
          {this.props[TSymbolProp].translate('NOTIFICATION_SETTINGS')}
        </Button>
      );
    }

    return null;
  }

  renderProfileSettings() {
    const { profileSettingsLink, isFedRAMP } = this.props;
    if (profileSettingsLink && !isFedRAMP) {
      return (
        <div className="UserMenu__user-profile-settings">
          <A href={this.props.profileSettingsLink} target="_blank">
            {this.props[TSymbolProp].translate('PROFILE_SETTINGS')}
          </A>
        </div>
      );
    } else {
      return null;
    }
  }

  /**
   *
   * @returns {VDOM}
   */
  render() {
    return (
      <div className="UserMenu">
        <UserAvatar user={this.props.user} />
        <div className="UserMenu__user-info">
          <div className="UserMenu__user-name" title={this.props.user.name}>
            {this.props.user.name}
          </div>
          <div className="UserMenu__user-email" title={this.props.user.email}>
            {this.props.user.email}
          </div>
          {this.renderProfileSettings()}
          {this.renderNotificationSettings()}
          <Button
            styleType={Button.StyleType.CANCEL}
            className="UserMenu__user-signout"
            onClick={() => this.signout()}
          >
            {this.props[TSymbolProp].translate('SIGNOUT')}
          </Button>
        </div>
      </div>
    );
  }
}

UserMenu.defaultProps = {
  onSignout: noop,
  openNotificationSettings: noop,
  hideNotificationSettings: false
};

UserMenu.propTypes = {
  /**
   * The locale to use for this component
   */
  locale: PropTypes.string.isRequired,
  /**
   * The url that will be loaded when the user requests to logout.
   * This url is a partial url that doesn't include the domain.
   */
  signoutURL: PropTypes.string,
  /**
   * A function that will be called when the user clicks on the sign out button.
   */
  onSignout: PropTypes.func,
  /**
   * The function to be called when `notification settings` is clicked
   */
  openNotificationSettings: PropTypes.func,
  /**
   * The user to show the menu popover for
   */
  user: PropTypes.shape({
    /**
     * The name of the user
     */
    name: PropTypes.string.isRequired,
    /**
     * The email of the user
     */
    email: PropTypes.string.isRequired
  }),
  /**
   * A link to Oxygen's account settings
   */
  profileSettingsLink: PropTypes.string,
  /**
   * Toggle notification settings button visibility
   */
  hideNotificationSettings: PropTypes.bool,
  /**
   * Flag for FedRAMP region modifications
   */
  isFedRAMP: PropTypes.bool
};

export default withLocale(UserMenu, ({ locale }) => new MDText(require(`./i18n/${locale}.json`)));
